<template>
  <div class="md-layout md-gutter">
    <div class="md-layout-item md-size-85">
      <sensor-autocomplete
        id="sensores"
        v-model="sensorId"
        name="sensores"
        :local-id="localId"
        :required="true"
      />
    </div>
    <div class="md-layout-item md-size-15">
      <md-field :class="getValidationClass('period')">
        <label>Periodo</label>
        <md-input
          v-model="periodo"
          v-mask="'##:##'"
          :required="true"
          @input="change"
        />
        <span v-if="!$v.periodo.validPeriod" class="md-error"
          >Data inválida</span
        >
      </md-field>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'

import { validaData } from '@/utils/validations/date'

import SensorAutocomplete from '../../autocomplete/SensorAutocomplete.vue'

export default {
  name: 'VerificaUltimoEnvio',
  components: { SensorAutocomplete },
  mixins: [validationMixin],
  props: {
    localId: {
      type: String,
      required: true,
    },
    initialSensorId: {
      type: String,
      default: null,
    },
    initialPeriodo: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    sensorId: null,
    periodo: '00:30',
  }),
  watch: {
    sensorId() {
      this.change()
    },
  },
  validations() {
    const validPeriod = (value) => {
      if (this.periodo) {
        return validaData(value)
      }
      return false
    }

    return {
      periodo: { validPeriod },
    }
  },
  beforeMount() {
    if (this.initialSensorId) {
      this.sensorId = this.initialSensorId
    }
    if (this.initialPeriodo) {
      this.periodo = this.initialPeriodo
    }
  },
  methods: {
    change() {
      this.$emit('change', {
        sensorId: this.sensorId,
        periodo: this.periodo,
      })
    },
    getValidationClass(fieldName) {
      const field = this.$v[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
  },
}
</script>

<style scoped></style>
